import { CONTRACT_TYPES_DICT } from '@/components/partials/jobs/JobsBackOffice/JobsBackOfficeEmployers/JobsBackOfficeEmployersTable/constants';
import { POSITION_ALL_KEY } from '@/components/partials/jobs/JobsBackOffice/JobsBackOfficeFilters/constants';
import type {
  FilterOption,
  MultiselectFilterSet,
  QueryParams,
} from '@/components/partials/jobs/JobsBackOffice/JobsBackOfficeFilters/types';
import {
  selectedOptionsToQueryParams,
  setSelectedMapper,
} from '@/components/partials/jobs/JobsBackOffice/JobsBackOfficeFilters/utils';
import { JobsModeratorsEmployerPlan, JobsModeratorsEmployersContractsContract } from '@/types/graphql';
import type { FilterKeysEmployers } from './types';

export const PLANS_FILTER_OPTIONS: FilterOption[] = [
  {
    title: 'Full',
    key: JobsModeratorsEmployerPlan.Full,
  },
  {
    title: 'Demo',
    key: JobsModeratorsEmployerPlan.Demo,
  },
  {
    title: 'All',
    key: POSITION_ALL_KEY,
  },
];

export const CONTRACT_TYPE_FILTER_OPTIONS: FilterOption[] = [
  {
    title: CONTRACT_TYPES_DICT[JobsModeratorsEmployersContractsContract.Payg],
    key: JobsModeratorsEmployersContractsContract.Payg,
  },
  {
    title: CONTRACT_TYPES_DICT[JobsModeratorsEmployersContractsContract.SideHustle],
    key: JobsModeratorsEmployersContractsContract.SideHustle,
  },
  {
    title: CONTRACT_TYPES_DICT[JobsModeratorsEmployersContractsContract.Saas],
    key: JobsModeratorsEmployersContractsContract.Saas,
  },
  {
    title: CONTRACT_TYPES_DICT[JobsModeratorsEmployersContractsContract.Contract],
    key: JobsModeratorsEmployersContractsContract.Contract,
  },
];

export const filterOptions: {
  [K in Extract<FilterKeysEmployers, 'contract_types' | 'plans'>]: FilterOption[];
} = {
  plans: PLANS_FILTER_OPTIONS.map(setSelectedMapper([POSITION_ALL_KEY])),
  contract_types: CONTRACT_TYPE_FILTER_OPTIONS.map(setSelectedMapper()),
};

export const DEFAULT_SELECTED_STATUSES = [JobsModeratorsEmployerPlan.Full];

export const EMPLOYERS_PAGE_DEFAULT_FILTERS: MultiselectFilterSet = Object.freeze({
  plans: DEFAULT_SELECTED_STATUSES,
});

export const EMPLOYERS_PAGE_DEFAULT_FILTERS_QUERY_PARAMS: QueryParams =
  selectedOptionsToQueryParams(EMPLOYERS_PAGE_DEFAULT_FILTERS);
